import { IGetActiveParticipantsAPIResponse } from "@/types/participants.types";
import { HTTP_METHODS } from "../constants/HttpConstants";
import { sendRequestToInterviewWithCredential } from "../utils/request.utils";

// eslint-disable-next-line import/prefer-default-export
export const getActiveParticipantsAPI = (interviewSlug: string) =>
  sendRequestToInterviewWithCredential<IGetActiveParticipantsAPIResponse>({
    method: HTTP_METHODS.GET,
    url: `/interviews/${interviewSlug}/participants/`,
  });
